import { useLocation, useNavigate } from "react-router-dom"

//Components
import Snack from "../../components/snack"
import Loader from "../../components/loader"
import NavBar from "./components/nav-bar"

//Extras
import { fontType } from "../../assets/extras"
import { memo, useCallback, useEffect, useState } from "react"
import { arrayUnion, collection, doc, getDoc, getDocs, query, updateDoc, where } from "firebase/firestore"
import { db } from "../../assets/connections"
import { main } from "../../assets/coach-assets/constants/colors"
import { FaTimes, FaCheck } from "react-icons/fa";

const CoachInfo = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const regId = location.state ? location.state.regId : null
    const ref = location.state ? location.state.ref : null
    const regRef = location.state ? location.state.regRef : null
    const id = location.state ? location.state.id : null

    //Variables principales del componente
    const [variables, setVariables] = useState({
        ref: ref,
        id: id,
        regRef: regRef,
        regId: regId,
        data: null,
        change: false,
        loading: true,
        students: []
    })

    //Formatea los dias de las clases
    const formatDays = (dias_clase) => {
        if (variables.id.split("-").length === 1 || variables.id.split("-")[2] === "TEMP") {
            let dias = ""
            let hora = ""
            dias_clase.map(v => {
                let dia = ""
                for (let i = 0; i < 3; i++) {
                    dia += v.dia[i]
                }
                if (dias) {
                    dias += " / " + dia
                } else {
                    dias = dia
                    hora = v.de + " a " + v.a
                }
            })
            return dias + " de " + hora
        }
        return "Hora asignada por el profesor"
    }

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")

            let snack = document.createElement("div")
            snack.classList.add("snack")

            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""

            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }


    //Funcion que quita las asistencias de un jugador
    const takeOutPlayer = (d, index) => {
        if (d.asist == true) {
            d = { ...d, asist: null }
        } else if (d.asist == null) {
            d = { ...d, asist: false }
        }

        variables.data.alumnos_clase.splice(index, 1)
        variables.students.push(d)

        setVariables(prev => ({
            ...prev,
            change: !variables.change
        }))
    }

    //Funcion para agregar jugador a las asistencias
    const insertPlayer = (d, index) => {
        if (d.asist == false) {
            d = { ...d, asist: null }
        } else if (d.asist == null) {
            d = { ...d, asist: true }
        }

        variables.data.alumnos_clase.push(d)
        variables.students.splice(index, 1)

        setVariables(prev => ({
            ...prev,
            change: !variables.change
        }))
    }

    //Funcion que actualiza la informacion del registro
    const updateReg = async () => {

        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        //Ahora vamos a agregar las asistencias en caso de que haya jugadores nuevos en las asistencias
        variables.data.alumnos_clase.map(async v => {
            if (v.asist == true) {
                await updateDoc(doc(doc(db, variables.ref), "Jugador", v.id), {
                    asistencias: arrayUnion({
                        fecha_clase: variables.data.fecha_clase,
                        nombre_clase: variables.data.nombre_clase,
                        profesor_clase: variables.data.nombre_profesor,
                        hora_clase: formatDays(variables.data.dias_clase),
                        id: variables.regId
                    })
                })
            }
        })

        //Actualizamos nuestras clases muestra
        variables.data.clasesMuestra.map(async (v, i) => {
            if (v.asisted != undefined) {
                if (v.asisted === false) {
                    await updateDoc(doc(db, "ClaseMuestra", v.id), {
                        asistio: false
                    })
                } else if (v.asisted === true) {
                    await updateDoc(doc(db, "ClaseMuestra", v.id), {
                        asistio: true
                    })
                }
            }
        })

        //Formateamos los datos de los jugadores que vamos a guardar
        for (let i = 0; i < variables.data.alumnos_clase.length; i++) {
            variables.data.alumnos_clase[i] = {
                id: variables.data.alumnos_clase[i].id,
                nombre: variables.data.alumnos_clase[i].nombre
            }
        }

        await updateDoc(doc(doc(db, variables.regRef), "Historial", variables.regId), { ...variables.data }).then(r => {

            //Primero vamos a quitar las asistencias en caso de que haya jugadores a los que quitamos asistencia
            variables.students.map(async v => {
                if (v.asist == false) {
                    await getDoc(doc(doc(db, variables.ref), "Jugador", v.id)).then(async r => {
                        if (r.exists()) {
                            let new_asistencias = r.data().asistencias
                            new_asistencias = new_asistencias.filter(v2 => v2.id != variables.regId)

                            await updateDoc(doc(doc(db, variables.ref), "Jugador", v.id), {
                                asistencias: new_asistencias
                            })
                        }
                    })
                }
            })

            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Registro modificado", "success")
            setTimeout(() => {
                navigate(-1, { replace: true });
            }, 2000)

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error al actualizar registro", "error")
        })
    }

    /**
     * FUNCIONES PARA LAS CLASES MUESTRA, TANTO AGREGAR COMO QUITAR ASISTENCIA
     */
    const asisted = (index) => {
        variables.data.clasesMuestra[index].asisted = true
        setVariables(prev => ({
            ...prev
        }))
    }
    const notAsisted = (index) => {
        variables.data.clasesMuestra[index].asisted = false
        setVariables(prev => ({
            ...prev,
            change: !prev.change
        }))
    }

    //Funcion que obtiene los datos del registro
    const getData = async () => {
        await getDoc(doc(doc(db, regRef), "Historial", regId)).then(r => {
            getStudents(r.data())
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }
    //Funcion que busca todos los alumnos que esten dentro de la clinica
    const getStudents = async (data) => {
        await getDocs(query(collection(doc(db, ref), "Jugador"), where("clases_jugador", "array-contains", id))).then(r => {
            let aux = []
            r.docs.map(v => {
                aux.push({
                    id: v.id,
                    nombre: v.data().nombre_jugador,
                    asist: null
                })
            })

            filterPlayers(data, aux)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }
    //Funcion que filtra a los jugadores de los que asistieron y de los que no
    const filterPlayers = (data, players) => {
        for (let i = 0; i < data.alumnos_clase.length; i++) {
            let currPlayer = data.alumnos_clase[i].id
            for (let j = 0; j < players.length; j++) {
                if (currPlayer == players[j].id) {
                    players.splice(j, 1)
                }
            }
        }

        const d = data

        setVariables(prev => ({
            ...prev,
            data: d,
            students: players,
            loading: false
        }))
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if(!token || !location.state) {
            navigate("/coach", {
                replace: true
            })
        } else {
            getData()
        }
    }, [])

    const HeaderComponent = memo(({ variables }) => {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "80%",
                    maxWidth: 500
                }}
            >

                {/* Texto introductorio */}
                <div
                    style={{
                        marginTop: "20px",
                        width: "70%",
                        marginBottom: "5px",
                        marginLeft: "20px",
                        fontSize: "16px",
                        fontFamily: fontType.text
                    }}
                >
                    La clase fue impartida
                </div>

                {/* Contenedor de detalles */}
                <div
                    style={{
                        width: "70%",
                        borderWidth: 2,
                        borderStyle: "solid",
                        borderRadius: "10px",
                        borderColor: main,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                        fontFamily: fontType.text
                    }}
                >
                    <div style={{ marginBottom: "10px" }}>
                        <span style={{ fontWeight: "bold" }}>Fecha:</span> {variables.data.fecha_clase}
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <span style={{ fontWeight: "bold" }}>Hora:</span> {variables.data.hora_clase} hrs
                    </div>
                    <div>
                        <span style={{ fontWeight: "bold" }}>Duración de clase:</span> {variables.data.duracion_clase} hrs
                    </div>
                </div>

                {/* Comentarios */}
                <div
                    style={{
                        fontSize: "14px",
                        marginTop: "10px",
                        fontStyle: "italic",
                        textAlign: "center",
                        width: "90%",
                        fontFamily: fontType.text
                    }}
                >
                    {variables.data.comentarios_clase
                        ? variables.data.comentarios_clase
                        : '"Sin comentarios"'}
                </div>

                {/* Título asistencias */}
                <div
                    style={{
                        marginTop: "20px",
                        fontFamily: fontType.title,
                        fontSize: "30px"
                    }}
                >
                    ASISTENCIAS
                </div>
            </div>

        )
    })

    const AsistenciasComponent = memo(({ variables, takeOutPlayer }) => {
        return (
            <div style={{
                width: "80%",
                maxWidth: 800
            }}>
                {
                    variables.data.alumnos_clase !== undefined ?
                        variables.data.alumnos_clase.length > 0 ?
                            variables.data.alumnos_clase.map((v, i) =>
                                <CardAsistencias
                                    data={v}
                                    index={i}
                                    takeOutPlayer={takeOutPlayer}
                                />
                            )
                            :
                            null
                        : null
                }
            </div>
        )
    })
    const CardAsistencias = memo(({ data, index, takeOutPlayer }) => {
        //Funcion que formatea el nombre de los jugadores para que quepan en el recuadro
        const formatName = useCallback((nombre) => {
            let name = ""
            let cont = 0
            for (let i = 0; i < nombre.length; i++) {
                name += nombre[i]
                cont++

                if (cont == 18) {
                    break
                }
            }

            if (cont == 18) {
                return name + "..."
            } else {
                return name
            }
        }, [])

        return (
            <div
                style={{
                    width: "100%",
                    height: "60px",
                    padding: "5px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    borderRadius: "10px",
                    border: "2px solid " + main,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.2)", // reemplazo de elevation
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "row"
                }}
            >
                {/* Nombre */}
                <span style={{ fontSize: "20px", fontWeight: "bold", fontFamily: fontType.text }}>
                    {formatName(data.nombre)}
                </span>

                {/* Botón de acción */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <button
                        onClick={() => takeOutPlayer(data, index)}
                        style={{
                            backgroundColor: "#991b1b", // equivalente a red.800
                            border: "none",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <FaTimes size={20} color="white" />
                    </button>
                </div>
            </div>

        )
    })

    const ReposicionesComponent = memo(({ variables }) => {

        return (
            <div>
                {
                    variables.data.jugadores_reposicion !== undefined ?
                        variables.data.jugadores_reposicion.length > 0 ?
                            variables.data.jugadores_reposicion.map((v, i) =>
                                <CardReposiciones
                                    data={v}
                                />
                            )
                            :
                            null
                        : null
                }
            </div>
        )
    })
    const CardReposiciones = memo(({ data }) => {

        //Funcion que formatea el nombre de los jugadores para que quepan en el recuadro
        const formatName = (nombre) => {
            let name = ""
            let cont = 0
            for (let i = 0; i < nombre.length; i++) {
                name += nombre[i]
                cont++

                if (cont == 27) {
                    break
                }
            }

            if (cont == 27) {
                return name + "..."
            } else {
                return name
            }
        }

        return (
            <div
                style={{
                    width: "100%",
                    height: "60px",
                    padding: "5px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    borderRadius: "10px",
                    border: "2px solid " + main,
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.2)", // reemplazo de elevation
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "row"
                }}
            >
                {/* Nombre */}
                <span style={{ fontSize: "20px", fontWeight: "bold", fontFamily: fontType.text }}>
                    {formatName(data.nombre_jugador)}
                </span>
            </div>
        )

    })

    const NoAsistidosComponent = memo(({ variables, insertPlayer }) => {
        return (
            <div>
                {
                    variables.students !== undefined ?
                        variables.students.length > 0 ?
                            variables.students.map((v, i) =>
                                <CardNoAsistidos
                                    data={v}
                                    index={i}
                                    insertPlayer={insertPlayer}
                                />
                            )
                            :
                            null
                        : null
                }
            </div>
        )
    })
    const CardNoAsistidos = memo(({ data, index, insertPlayer }) => {
        //Funcion que formatea el nombre de los jugadores para que quepan en el recuadro
        const formatName = useCallback((nombre) => {
            let name = ""
            let cont = 0
            for (let i = 0; i < nombre.length; i++) {
                name += nombre[i]
                cont++

                if (cont == 18) {
                    break
                }
            }

            if (cont == 18) {
                return name + "..."
            } else {
                return name
            }
        }, [])

        return (
            <div
                style={{
                    width: "100%",
                    height: "60px",
                    padding: "5px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    borderRadius: "10px",
                    border: "2px solid " + main,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.2)", // reemplazo de elevation
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "row"
                }}
            >
                {/* Nombre */}
                <span style={{ fontSize: "20px", fontWeight: "bold", fontFamily: fontType.text }}>
                    {formatName(data.nombre)}
                </span>

                {/* Botón de acción */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <button
                        onClick={() => insertPlayer(data, index)}
                        style={{
                            backgroundColor: "#15803d", // equivalente a red.800
                            border: "none",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <FaCheck size={20} color="white" />
                    </button>
                </div>
            </div>

        )
    })

    const MuestrasComponent = memo(({ variables, asisted, notAsisted }) => {
        return (
            <div>
                {
                    variables.data.clasesMuestra.map((v, i) =>
                        <CardMuestras
                            data={v}
                            index={i}
                            asisted={asisted}
                            notAsisted={notAsisted}
                        />
                    )
                }
            </div>
        )
    })
    const CardMuestras = memo(({ data, index, asisted, notAsisted }) => {
        return (
            <div
                style={{
                    width: "100%",
                    height: "60px",
                    padding: "5px",
                    marginTop: "20px",
                    marginBottom: "5px",
                    borderRadius: "10px",
                    border: `2px solid ${main}`,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.2)", // reemplazo de elevation
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "row",
                }}
            >
                {/* Nombre */}
                <span style={{ fontSize: "20px", fontWeight: "bold", fontFamily: fontType.title }}>
                    {data.nombre}
                </span>

                {/* Botón de acción */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                    {data.asisted !== undefined ? (
                        data.asisted === true ? (
                            <button
                                onClick={() => notAsisted(index)}
                                style={{
                                    backgroundColor: "#991b1b", // red.800
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "6px 10px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <FaTimes size={20} color="white" />
                            </button>
                        ) : (
                            <button
                                onClick={() => asisted(index)}
                                style={{
                                    backgroundColor: "#15803d", // green.700
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "6px 10px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <FaCheck size={20} color="white" />
                            </button>
                        )
                    ) : (
                        <button
                            onClick={() => notAsisted(index)}
                            style={{
                                backgroundColor: "#991b1b", // red.800
                                border: "none",
                                borderRadius: "6px",
                                padding: "6px 10px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <FaTimes size={20} color="white" />
                        </button>
                    )}
                </div>
            </div>
        )
    })

    const Footer = memo(({ variables }) => {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 30,
                    flexDirection: "column",
                    width: "80%",
                    maxWidth: 800,
                    marginBottom: 50
                }}
            >
                {/* Título */}
                <span
                    style={{
                        fontFamily: fontType.title,
                        fontSize: "30px",
                    }}
                >
                    LECCION
                </span>

                {/* Botón de lección */}
                <button
                    style={{
                        backgroundColor: "black",
                        padding: "10px",
                        width: "60%",
                        borderRadius: "20px",
                        marginTop: "8px", // equivalente a mt={2}
                        border: "none",
                        cursor: "default",
                    }}
                >
                    <span
                        style={{
                            color: "white",
                            fontFamily: fontType.title,
                            fontSize: "18px",
                        }}
                    >
                        {variables.data.leccion_clase}
                    </span>
                </button>

                {/* Botón de actualizar */}
                <button
                    onClick={updateReg}
                    style={{
                        marginTop: 20,
                        backgroundColor: main, // equivalente a green.700
                        width: "80%",
                        borderRadius: "10px",
                        border: "none",
                        cursor: "pointer",
                        padding: 20
                    }}
                >
                    <span
                        style={{
                            margin: "10px",
                            fontFamily: fontType.title,
                            fontSize: "20px",
                            color: "white",
                        }}
                    >
                        ACTUALIZAR
                    </span>
                </button>
            </div>
        )

    })

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div style={{
                flex: 1
            }}>
                <Snack />

                <NavBar
                    title={variables.data.nombre_clase}
                />

                {
                    variables.data.wasGiven ?
                        <div
                            style={{
                                display: "flex",
                                flex: 1,
                                alignItems: "center",
                                flexDirection: "column"
                            }}
                        >

                            <HeaderComponent
                                variables={variables}
                            />

                            <AsistenciasComponent
                                variables={variables}
                                takeOutPlayer={takeOutPlayer}
                            />

                            {
                                variables.data.jugadores_reposicion !== undefined ?
                                    variables.data.jugadores_reposicion.length > 0 ?
                                        <div style={{
                                            width: "80%",
                                            maxWidth: 800
                                        }}>
                                            <p style={{
                                                marginTop: 50,
                                                fontFamily: fontType.title,
                                                fontSize: 30,
                                                textAlign: "center"
                                            }}>REPOSICIONES</p>

                                            <ReposicionesComponent
                                                variables={variables}
                                            />
                                        </div>
                                        : null
                                    :
                                    null
                            }

                            {
                                variables.students.length > 0 ?
                                    <div style={{
                                        width: "80%",
                                        maxWidth: 800
                                    }}>
                                        <p style={{
                                            marginTop: 50,
                                            fontFamily: fontType.title,
                                            fontSize: 30,
                                            textAlign: "center"
                                        }}>JUGADORES NO ASISTIDOS</p>

                                        <NoAsistidosComponent
                                            variables={variables}
                                            insertPlayer={insertPlayer}
                                        />

                                    </div>
                                    : null
                            }

                            {
                                variables.data.clasesMuestra.length > 0 ?
                                    <div style={{
                                        width: "80%",
                                        maxWidth: 800
                                    }}>
                                        <p style={{
                                            marginTop: 50,
                                            fontFamily: fontType.title,
                                            fontSize: 30,
                                            textAlign: "center"
                                        }}>CLASES MUESTRA</p>

                                        <MuestrasComponent
                                            variables={variables}
                                            asisted={asisted}
                                            notAsisted={notAsisted}
                                        />

                                    </div>
                                    : null
                            }

                            <Footer
                                variables={variables}
                            />

                        </div>
                        :
                        <div
                            style={{
                                display: "flex",
                                flex: 1,
                                alignItems: "center",
                                flexDirection: "column"
                            }}
                        >

                            {/* Fecha y hora */}
                            <div style={{ marginTop: "50px", fontSize: "16px", fontFamily: fontType.text }}>
                                {variables.data.fecha_clase} | {variables.data.hora_clase}
                            </div>

                            {/* Caja de detalles */}
                            <div
                                style={{
                                    width: "80%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid black",
                                    marginTop: "5px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center"
                                }}
                            >
                                {/* Razones */}
                                <div style={{ textAlign: "center", fontFamily: fontType.text }}>
                                    <span>La clase no fue impartida: </span>
                                    <div
                                        style={{
                                            fontFamily: fontType.text,
                                            marginTop: "5px"
                                        }}
                                    >
                                        {variables.data.reasons}
                                    </div>
                                </div>

                                {/* Detalles */}
                                <textarea
                                    readOnly
                                    style={{
                                        width: "90%",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px",
                                        padding: "5px",
                                        height: "100px",
                                        marginTop: "20px",
                                        color: "black",
                                        resize: "none"
                                    }}
                                    value={
                                        variables.data.details === ""
                                            ? "No hay más razones..."
                                            : variables.data.details
                                    }
                                />

                                {/* Duración */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "row",
                                        marginTop: "10px",
                                        fontFamily: fontType.text
                                    }}
                                >
                                    <span style={{ fontWeight: "bold" }}>Duración de clase: </span>
                                    <span>{variables.data.duracion_clase} hrs</span>
                                </div>
                            </div>
                        </div>

                }

            </div>
        )
}

export default CoachInfo